// - Import action types
import { AuthorizeActionType } from 'constants/authorizeActionType';
import { AuthorizeState } from './AuthorizeState';
import { Map } from 'immutable';
/**
 *  Authorize reducer
 * @param {object} state
 * @param {object} action
 */
export var authorizeReducer = function (state, action) {
    if (state === void 0) { state = Map(new AuthorizeState()); }
    var payload = action.payload;
    switch (action.type) {
        case AuthorizeActionType.LOGIN:
            return state
                .set('uid', payload.uid)
                .set('authed', true)
                .set('guest', false)
                .set('isVerifide', payload.isVerifide);
        case AuthorizeActionType.LOGOUT:
            return state
                .set('uid', 0)
                .set('authed', false)
                .set('guest', true)
                .set('isVerifide', false);
        case AuthorizeActionType.SIGNUP:
            return state
                .set('uid', payload.userId);
        case AuthorizeActionType.UPDATE_PASSWORD:
            return state
                .set('updatePassword', payload.updatePassword);
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/authorize/authorizeReducer.ts
// module id = 551
// module chunks = 50